export const COMMAND = {
  CANCEL: Symbol('USER_ANSWER:CANCEL'),
  NOT_ALLOWED_OK: Symbol('USER_ANSWER:NOT_ALLOWED_OK'),
};

export const isCancelCommand = (target: any): target is typeof COMMAND.CANCEL =>
  target === COMMAND.CANCEL;

export const isSafeCancel = (target: any): boolean => {
  return target === COMMAND.NOT_ALLOWED_OK || target === COMMAND.CANCEL;
};
